import { useEffect, useState } from "react";
import { useFeatures } from "~/context/FeaturesContext";

import Link from "next/link";
import { Menu, Space } from "antd";

import { getGroupCategories } from "~/services/groups";

const GroupNavs = ({ active = "" }) => {
  const features = useFeatures();
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [groupCategories, setGroupCategories] = useState([]);
  const [selected, setSelected] = useState(active);

  const items = [
    {
      label: (
        <Link
          legacyBehavior
          href="/groups"
        >
          <a>全部</a>
        </Link>
      ),
      key: "",
    },
  ];
  groupCategories.forEach((x) =>
    items.push({
      label: (
        <Link
          legacyBehavior
          href={`/groups?category=${x.id}`}
        >
          <a>
            {x.name} ({x.groups_count})
          </a>
        </Link>
      ),
      key: x.id,
    })
  );

  items.push({ type: "divider" });
  items.push({
    label: (
      <Link
        legacyBehavior
        href="/groups/new"
      >
        <a>申请/推荐收录</a>
      </Link>
    ),
    key: "new",
  });
  items.push({
    label: (
      <Link
        legacyBehavior
        href="/groups/managed/"
      >
        <a>群组管理</a>
      </Link>
    ),
    key: "group_manage",
  });

  if (features["group_manage"]) {
    if (features["group_post"] && features["group_post_wechat"]) {
      items.push({
        label: (
          <Link
            legacyBehavior
            href="/groups/posts/"
          >
            <a>群聊精华</a>
          </Link>
        ),
        key: "group_post",
      });
    }
  }

  const handleClick = ({ key }) => {
    setSelected(key);
  };

  const checkScreenSize = () => {
    setIsSmallScreen(window.innerWidth < 768);
  };

  useEffect(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    getGroupCategories().then(setGroupCategories);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ display: "flex" }}
    >
      <Menu
        items={items}
        mode={isSmallScreen ? "horizontal" : "vertical"}
        selectedKeys={[selected]}
        onClick={handleClick}
      />
    </Space>
  );
};

export default GroupNavs;
